import { ILogisticsProvider } from './logistics-provider';

export interface ILogisticsProviderListResponse {
    data: {
        success: boolean;
        results: ILogisticsProvider[];
    }
}
